export default {"src":"/_next/static/media/kyanlogo.2b416915.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};